import type { AxiosInstance } from "axios";
import { api as legacyApi, createApiFunctions as createLegacyApiFunctions } from "./api";
import { api as coreApi, createApiFunctions as createCoreApiFunctions } from "./coreApi";
import { toastError } from "components/Toast/Toast";

const legacy = createLegacyApiFunctions(site.deploymentValues.legacyPageBaseUrl, serverReference.culture.uiLocale);
const core = createCoreApiFunctions(site.deploymentValues.coreApiBaseUrl, serverReference.culture.uiLocale);
window.CoreApi = core;
window.Api = legacy;


// Interceptor checks for:
// - 403 response with invalidLoginSession error code in body -> redirect to target URL
// - 403 response with { "statusCode": 403 } body -> show rate limit error modal
export const addInterceptors = (api: AxiosInstance) => {
  api.interceptors.response.use(
    (response) => {
      if (response.config.systemOneApiConfig?.toastOnError && response.data && "hasErrors" in response.data && "errors" in response.data) {
        const apiResponse = response.data as server.dto.ApiResponse;
        if (apiResponse.hasErrors) {
          const errorMessage = apiResponse.errors[0].message;
          toastError(errorMessage);
        }
      }

      return response;
    },
    (error) => {

      // Some errors don't have responses, like CORS errors
      if (error.response && error.response.data && error.response.status === 403) {

        // Check if this is a SystemOne response
        if ("hasErrors" in error.response.data && "errors" in error.response.data) {
          const response = error.response.data as server.dto.ApiResponse;
          if (response.hasErrors) {
            const revokedForCheatingError = response.errors.find(e => e.code === "invalidLoginSession")
            if (revokedForCheatingError) {
              window.location.href = revokedForCheatingError.target;
            }
          }
        }
        // Check if rate limit has been hit
        // Azure returns 403 response with { "statusCode": 403 } body, so we check for that
        else if (error.response.data?.statusCode === 403) {
          window.displayGenericModal("Error", "Maximum allowed number of actions has been exceeded. Try again at later point.", "mini", "red");
        }
      }

      if(error.response == null && error.config.systemOneApiConfig?.toastOnError) {
        toastError(RESX.GeneralLabels.SomethingUnexpectedHappened);
      }
      return Promise.reject(error);
    });
}

addInterceptors(legacyApi);
addInterceptors(coreApi);